<template>
<div>
  <div class="tasksTop">
    <div class="topSeach">
      <div class="innerSearch">
        <el-input placeholder="Search" v-model="invoice_input" class="input-with-select" id="topInput">
          <el-select v-model="selects" slot="prepend" style="width: 100px">
            <el-option label="Invoice#" value="invoice#"></el-option>
          </el-select>
        </el-input>
      </div>
      <div class="innerSearch">
        <el-select v-model="driver_input" placeholder="All">
          <el-option
            v-for="item in driver_option"
            :key="item.worker_id"
            :label="item.name"
            :value="item.worker_id">
          </el-option>
          <div slot="prefix" >
            Drivers:
          </div>
          <div style="clear: both">
          </div>
        </el-select>
      </div>
      <div class="innerSearch">
        <el-select v-model="group_input" placeholder="All">
          <el-option
            v-for="item in group_option"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
          <div slot="prefix" >
            Group:
          </div>
          <div style="clear: both">
          </div>
        </el-select>
      </div>
      <div class="innerSearch cascader">
        <div class="innerTime from">
          <el-date-picker
            v-model="time1"
            type="date"
            :clearable="false"
            placeholder="Select a date"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="chooseDate"
          >
          </el-date-picker>
          <div class="slot">Form:</div>
        </div>
      </div>
      <div class="innerSearch cascader">
        <div class="innerTime to">
          <el-date-picker
            v-model="time2"
            type="date"
            :clearable="false"
            placeholder="Select a date"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="chooseDate"
          >
          </el-date-picker>
          <div class="slot">To:</div>
        </div>
      </div>
      <div class="innerSearch">
        <el-button type="warning"
                   style="background: #ffc215; border: 1px solid #ffc215 !important" round
                   @click="downloadFailHandle"
        >Download </el-button>
        <el-button type="success" round @click="seachHandle" style="width: 80px;padding: 0">Search</el-button>
        <el-button plain @click="clearAll" style="width: 80px" class="changeFocus">Clear</el-button>
      </div>
    </div>
  </div>
  <div class="failure_list">
    <el-row >
      <el-col :span="3"><div class="grid-content bg-purple">Driver’s name</div></el-col>
      <el-col :span="5"><div class="grid-content bg-purple">Driver Note</div></el-col>
      <el-col :span="3"><div class="grid-content bg-purple">Invoice#</div></el-col>
      <el-col :span="3"><div class="grid-content bg-purple">Distance</div></el-col>
      <el-col :span="3"><div class="grid-content bg-purple">Duration</div></el-col>
      <el-col :span="3"><div class="grid-content bg-purple">Reason</div></el-col>
      <el-col :span="4"><div class="grid-content bg-purple">Actions</div></el-col>
    </el-row>
  </div>
  <div class="failure_list_data"  v-loading="fail_loading" v-if=" total != 0">
     <div class="out_list" v-for="(value,key) in failure_list" :key="key">
        <div style="text-align: left">{{key}}</div>
          <div v-for="(item,index) in  value" :key="index" class="list_mes">
            <el-row  justify="center"  align="middle" >
            <el-col :span="3"><div class="grid-content bg-purple ">{{item.worker_name}}</div></el-col>
            <el-col :span="5"><div class="grid-content bg-purple" style="text-align: left">{{item.failure_note}}</div></el-col>
            <el-col :span="3"><div class="grid-content bg-purple invoice_click " @click="showDetialHandle(item)">{{item.invoice_number}}</div></el-col>
            <el-col :span="3"><div class="grid-content bg-purple ">{{item.distance}}</div></el-col>
            <el-col :span="3"><div class="grid-content bg-purple ">{{item.duration_time}}</div></el-col>
            <el-col :span="3"><div class="grid-content bg-purple ">{{item.failure_reason}}</div></el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple">
                <div class="table_switch">
                  <el-switch
                    v-model="item.is_audit"
                    active-color="#82D237"
                    :active-value="1"
                    :inactive-value ='0'
                    inactive-color="#CCCCCC"
                    :width="20"
                    @change="e => { changeSwitchHandle(e, item);}"
                  >
                  </el-switch>
                </div>
                <div class="table_edit" @click="openNoteHandle(item)">
                  <img src="../assets/image/edit@2x.png" alt="">
                </div>
            </div>
            </el-col>
          </el-row>
            <div class="btom_note" v-if="item.audit_note != null && item.audit_note != ''">Audit Note:{{item.audit_note}}</div>
            <div v-else style="height: 20px"></div>
          </div>
     </div>
  </div>
  <div v-else class="empty">
    <div>
      <img src="../assets/image/list_blank.png" alt="">
      <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
    </div>
  </div>
  <div class="btomPagin" >
    <div class="innerLeft">{{page}} - <span>{{limit}}</span> of <span>{{total}}</span> items</div>
    <div>
      <el-pagination
        :page-size="10"
        layout="prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
  <!--  详情dialog-->
  <el-dialog
    :close-on-click-modal="false"
    custom-class="right"
    title="Task Details"
    :visible.sync="detialDialog"
    width="30%">
    <task-detial :info="info" ref="taskDetialRef"></task-detial>
  </el-dialog>
  <!--  添加note dialog-->
  <el-dialog
    :close-on-click-modal="false"
    title="Audit Note"
    :visible.sync="noteDialog"
    width="40%">
    <div style="text-align: left">
          <el-input   placeholder="Audit Note"
                      type="textarea"
                      autocomplete="off"
                      id="allInput"
                      maxlength="200"
                      :autosize="{ minRows: 4,}"
                      show-word-limit
                      v-model="note_input"
                      style="margin-top: 16px"
          ></el-input>
          <div slot="error"></div>
    </div>
    <span slot="footer" class="dialog-footer">
     <el-button type="danger" @click="noteDialog = false" plain>Cancel</el-button>
    <el-button type="primary" @click="saveEditHandle">Save</el-button>
  </span>
  </el-dialog>
</div>
</template>

<script>
import taskDetial from "@/components/taskDetial";
import {getDriverList} from "@/api/tasks";
import {changeSwitch, exportFailTasks, getfailList, updatefailNote} from "@/api/faliureReview";
import layout from "@/view/layout";
import {getGroupList} from "@/api/driver";
export default {
  name: "FailureReview",
  components:{
    taskDetial
  },
  data(){
    return{
      fail_loading:false,
      note_input:'',
      noe_row:'',
      noteDialog:false,
      invoice_input:'',
      selects:'invoice#',
      group_option:[],
      group_input:'',
      detialDialog:false,
      driver_input:'',
      driver_option:[],
      time1:'',
      time2:'',
      info:'',
      page:1,
      total:10,
      limit:10,
      failure_list:{}
    }
  },
  created() {
    this.getDriver()
    this.getGroup()
    this.getFailDataListHandle()
  },
  methods:{
    downloadFailHandle(){
      exportFailTasks({
        invoice_number:this.invoice_input,
        start_time:this.time1,
        end_time:this.time2,
      }).then(res=>{
        if (res.code == 200){
          this.download(res.data.file)
        }else {
          this.$message({
            type:"warning",
            message:res.msg
          })
        }
      })
    },
    download(url){
        const link = document.createElement('a')
        link.href = 'https://work.back.rapidi.ca/storage/' + url
        link.setAttribute('download', '文件名字' + Date.now() + '.xls') // 下载文件的名称及文件类型后缀
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) // 下载完成移除元素
    },
    //修改switch
    changeSwitchHandle(e,row){
      changeSwitch({
        id:row.id,
        is_autid:e
      }).then(res=>{

      })
    },
    //打开note弹框
    openNoteHandle(row){
      this.noteDialog = true
      this.note_input = row.audit_note
      this.noe_row = row
    },
    saveEditHandle(){
      updatefailNote({
        id: this.noe_row.id,
        audit_note:this.note_input
      }).then(res=>{
        if (res.code == 200){
          this.noteDialog = false
          this.$message({
            type:'success',
            message:'Edited Successfully'
          })
          this.getFailDataListHandle()
        }
      })
    },
    getFailDataListHandle(){
      this.fail_loading = true
      getfailList({
        "page": this.page,
        worker_id:this.driver_input,
        start_time:this.time1,
        end_time:this.time2,
        invoice_number:this.invoice_input,
        group_id:this.group_input
      }).then(res=>{
        this.fail_loading = false
          if (res.code == 200){
            this.failure_list = res.data.data
            // console.log(this.failure_list,'failure_list')
            this.total = res.data.count
          }
      })
    },
    getDriver(){
      getDriverList({token:localStorage.getItem('token')}).then(res=>{
        this.driver_option = res.data
      })
    },
    getGroup(){
      getGroupList({page:1,limit:''}).then(res=>{this.group_option = res.data.data})
    },
    handleCurrentChange(val){
      this.page = val
      this.getFailDataListHandle()
    },
    showDetialHandle(i){
      this.info = i
      this.detialDialog = true
      setTimeout(()=>{
        this.$refs.taskDetialRef.getData()
      },100)
    },
    //搜索
    seachHandle(){
      this.page = 1
      this.getFailDataListHandle()
    },
    clearAll(){
      this.time2 = ''
      this.time1 = ""
      this.driver_input = ''
      this.group_input = ''
      this.invoice_input = ''
      this.getFailDataListHandle()
    },
    chooseDate(){
      let t1 = this.time1
      let t2 = this.time2
      if (t1 && t2){
        if (new Date(t2).getTime()- new Date(t1).getTime()>= 360*1000*3600*24){
          this.$message({
            message: 'The number of days selected cannot exceed 360 days',
            type: 'warning',
          });
          this.time1 = ''
          this.time2 = ''
        }
      }
    },
  }
}
</script>

<style scoped lang="less">
/deep/.el-col{
  border: 1px solid transparent;
}
.tasksTop{
  padding: 8px;
  background: #FFFFFF;
  border-radius: 16px;
  border: 1px solid #E0E0E0;
  display: flex;
  justify-content: space-between;
  /deep/.changeFocus:focus{
    border: 1px solid #DCDFE6;
    color: #606266;
  }
  .topSeach{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    /deep/ .el-input--prefix .el-input__inner{
      padding-left: 88px;
    }
    /deep/ .el-input__prefix{
      color: #1F2D42;
    }
    .long_search{
      /deep/.el-input__inner{
        padding-left: 115px!important;
      }
    }
    .long_searchs{
      /deep/.el-input__inner{
        padding-left: 133px!important;
      }
    }
    .innerSearch{
      margin: 8px;
      /deep/.el-cascader{
        line-height: 0;
      }
      .innerTime{
        /deep/.el-input__prefix{
          position: absolute;
          top: 0;
          right: 12px;
          left: auto;
        }
        /deep/ .el-input--prefix .el-input__inner{
          padding-left: 12px;
        }
        /deep/.el-input__icon{
          //position: absolute;
          //right: 12px;
          color: #D65953;
        }
      }
      .from{
        /deep/.el-input__inner{
          padding-left: 75px!important;
        }
      }
      .to{
        /deep/.el-input__inner{
          padding-left: 55px!important;
        }
      }
    }
    .cascader{
      position: relative;
      /deep/.el-input__inner{
        padding-left: 80px;
      }
      .slot{
        position: absolute;
        padding-left: 24px;
        font-size: 14px;
        top: 5px;
      }
    }
    .ex{
      width: 300px;
      /deep/ .el-input--prefix .el-input__inner{
        padding-left: 110px;
      }
    }
  }

}

.failure_list{
  padding: 20px 8px;
  background: #FFFFFF;
  border-radius: 16px;
  margin: 16px 0 24px;
}
.list_mes{
  padding: 20px 0 0;
  background: #FFFFFF;
  border-radius: 16px;
  margin: 16px 0;

  font-size: 14px;
  font-family: SFPro, SFPro;
  font-weight: 400;
  color: #1F2D42;
  //line-height: 20px;
  .table_switch{
    display: inline-block;
    //width: 44px;
  }
  .table_edit{
    display: inline-block;
    cursor: pointer;
    img{
      width: 16px;
      height: 16px;
    }
    margin-left: 16px;
  }
  .invoice_click{
    cursor: pointer;
    color: #E95646;
  }
  .btom_note{
    text-align: left;
    background-color: #FFC215;
    margin-top: 20px;
    color: #ffffff;
    line-height: 20px;
    border-bottom-right-radius: 16px;
    border-bottom-left-radius: 16px;
    padding: 12px 48px;
  }

}
.empty{
  width: 200px;
  height: 387px;
  margin: 20px auto;
  text-align: center;
  position: relative;
  div{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  h2{
    font-size: 16px;
  }
  img{
    width: 100%;
    height: 200px;
    margin: 0;
  }
}
.btomPagin{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  padding-left: 16px;
  .innerLeft{
    font-size: 16px;
    font-family: SFPro-Regular, SFPro;
    font-weight: 400;
    color: #1F2D42;
    line-height: 20px;
  }
}
/deep/.el-switch__core{
  width: 60px!important;
  //height: 32px;
}
</style>
